// extracted by mini-css-extract-plugin
export default {"wrapper":"UserPage_wrapper_DhM0o"};